import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddEditAcademicCalanderDialog from './AddEditAcademicCalender';
import moment from 'moment';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { useCatchResponse } from '../../../utils/useCatchResponse';


const AcademicCalendarTemplate = () => {
    const { catchResponse } = useCatchResponse();
    const [academicCalanderList, setAcademicCalanderTemplateList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        AcademicCalanderTemplate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [expandedRows, setExpandedRows] = useState(null);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetAcademicCalanderTemplateList(loginData?._id);
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetAcademicCalanderTemplateList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getAcademicCalanderTemplateList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setAcademicCalanderTemplateList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center p-jc-end'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                        setMasterData(rows);
                        setVisible(true)
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-my-0 p-mr-0 p-ml-2" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                </div>
            </React.Fragment>

        );
    };

    const startDateBodyTemplate = (rows, type) => {
        return (
            <div>{moment(rows?.StartDate).format("DD-MM-YYYY")}</div>
        );
    };

    const endDateBodyTemplate = (rows) => {
        return (
            <div>{moment(rows?.EndDate).format("DD-MM-YYYY")}</div>
        );
    };

    const onCancel = () => {
        setVisible(false);
        setMasterData([]);
        GetAcademicCalanderTemplateList(securityUserID);
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => UpdateStatus()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const UpdateStatus = async () => {
        try {
            let data = {
                id: deleteId,
            }
            await api.post(APIConstant.path.deleteAcademicCalanderTemplate, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Academic calander deleted successfully' });
                    GetAcademicCalanderTemplateList(securityUserID);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getChildData = (rowData) => {
        return rowData?.CalendarValue || [];
    };

    const childTemplate = (rowData) => {
        return (
            <div className="custom-large-table">
                <DataTable
                    className="main-table table-td p-p-0"
                    editMode="row"
                    dataKey="id"
                    responsiveLayout="scroll"
                    value={getChildData(rowData)}
                >
                    <Column field="Index" header="Sr.No" body={actionBodyTemplateSrNo}></Column>
                    <Column
                        body={startDateBodyTemplate}
                        header="Start Date"
                        style={{ width: '30%' }}
                    />
                    <Column
                        body={endDateBodyTemplate}
                        header="End Date"
                        style={{ width: '30%' }}
                    />
                </DataTable>
            </div>
        );
    };

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-calendar-plus"></i>
                    <h2>Academic Calendar</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                </div>
            </div>
            {/* <DataTable
                value={academicCalanderList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                responsiveLayout="scroll"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
            >
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{ width: '15%' }} />
                <Column
                    field="TitleName"
                    header="Title"
                    style={{ width: '30%' }}
                />
                <Column
                    body={startDateBodyTemplate}
                    header="Start Date"
                    style={{ width: '30%' }}
                />
                <Column
                    body={endDateBodyTemplate}
                    header="End Date"
                    style={{ width: '30%' }}
                />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ display: 'flex', justifyContent: 'end' }} />
            </DataTable> */}
            <DataTable
                value={academicCalanderList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                responsiveLayout="scroll"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                onPage={onPageChange}
                className="custom-table"
                scrollHeight="calc(100vh - 120px)"
                size="small"
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={childTemplate}
                dataKey="id"
            >
                <Column expander style={{ width: "3rem" }} />
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{ width: '15%' }} />
                <Column field="TitleName" header="Title" style={{ width: '30%' }} />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '100%'}} />
            </DataTable>

            <Dialog
                header={masterData?._id ? 'Edit Academic Calander' : 'Add Academic Calander'}
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: '60vw' }}
            >
                <AddEditAcademicCalanderDialog onCancel={onCancel} configId={masterData?._id} masterData={masterData} templateFullData={academicCalanderList} />

            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
};

export default AcademicCalendarTemplate;
